import { faUser } from "@fortawesome/pro-regular-svg-icons";

import { useWorkspaceUsers } from "src/api/taktile/queries";
import { Select } from "src/base-components/Select";
import { Avatar } from "src/design-system/Avatar";
import { EmptyState } from "src/design-system/EmptyState";
import { useParamsDecode } from "src/utils/useParamsDecode";
import { canUserBeAssignee, getUserName } from "src/utils/user";

export const WorkspaceMembersSelect: React.FC<{
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
  dataLoc?: string;
  placeholder?: string;
}> = ({
  value,
  onChange,
  disabled,
  dataLoc,
  placeholder = "Select members",
}) => {
  const { orgId, wsId } = useParamsDecode<{ orgId: string; wsId: string }>();
  const { data: users = [], isLoading } = useWorkspaceUsers(orgId, wsId, {
    include_deactivated: false,
  });

  const options = users
    .filter((user) => canUserBeAssignee(wsId, user))
    .map((user) => ({
      key: user.id,
      searchText: getUserName(user),
      value: (
        <span className="flex items-center gap-x-2">
          <Avatar user={user} />
          {getUserName(user)}
        </span>
      ),
    }));

  return (
    <Select
      dataLoc={dataLoc}
      disabled={disabled || isLoading}
      dropdownPlaceholder={
        <EmptyState
          description="No users matching your search. Try adjusting your search term."
          headline="No users found"
          icon={faUser}
        />
      }
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      value={value}
      multiple
      searchable
      showResetButton
      onChange={onChange}
    />
  );
};
